import DS from 'components/Search/DocumentSearch'
import createWrappedField from './createWrappedField'

export default createWrappedField({
  Component: DS,
  name: 'DDIDocumentSearch'
})
